export const URL_AWS_CONSOLE = "https://console.aws.amazon.com/"

export const getAwsConsoleUrl = (spaceRegion: string, vpcId: string) =>
  `https://console.aws.amazon.com/vpcconsole/home?region=${spaceRegion}#VpcDetails:VpcId=${vpcId}`
